import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { BrandsLayoutProps } from "./types";



const BrandsLayout: FC<BrandsLayoutProps> = ({ children }) => {
  return (
    <>
      <TopNav title="Brands" />
      <ContentLayout>{children}</ContentLayout>
    </>
  );
};

export default BrandsLayout;
